import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link as LinkNav } from 'react-router-dom';
import {
  Icon,
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  Stack,
  Image,
  Text,
  useColorModeValue,
  Container,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  MenuOptionGroup,
  MenuItemOption,
  Tooltip,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { ColorModeSwitcher } from './../../styles/ColorModeSwitcher';
import PerfilPhoto from '../PerfilPhoto';
import ButtonPopver from '../ButtonPopver';
import LinkButton from '../LinkButton';
import ItemMenu from '../ItemMenu';
import ButtonSanfona from '../ButtonSanfona';
import IconNotification from './../IconNotification/index';
import logo from '../../Assets/Png/logo.png';
import { UserContext } from '../../Context/UserContext';
import NotificacoesBanner from '../NotificacoesBanner';
import { SocketContext } from '../../Context/SocketContext';
import { playSynthesizedSound } from '../../utils/soundUtils';
import {
  FaUserFriends,
  FaBusinessTime,
  FaCalendarTimes,
  FaCalendarPlus,
  FaShippingFast,
  FaHistory,
  FaUsers,
  FaBell,
  FaVolumeUp,
  FaVolumeMute,
  FaPlay,
} from 'react-icons/fa';
import { GoFileSubmodule } from 'react-icons/go';

export function Header() {
  const { login, IsLogin, isOpen, onOpen, onClose } = React.useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [userLogado] = React.useState(
    JSON.parse(window.localStorage.getItem('UserData'))
  );

  const socket = React.useContext(SocketContext);
  const [isMuted, setIsMuted] = React.useState(() => {
    return localStorage.getItem('sia_sound_muted') === 'true';
  });
  const [soundChoice, setSoundChoice] = React.useState(() => {
    return Number(localStorage.getItem('sia_sound_choice')) || 1;
  });

  const handleToggleMute = () => {
    const newVal = !isMuted;
    setIsMuted(newVal);
    localStorage.setItem('sia_sound_muted', String(newVal));
  };

  const handleSelectSound = (value) => {
    const choice = Number(value);
    setSoundChoice(choice);
    localStorage.setItem('sia_sound_choice', String(choice));
    playSynthesizedSound(choice);
  };

  const handleTestSound = (e) => {
    e.stopPropagation();
    playSynthesizedSound(soundChoice);
  };

  React.useEffect(() => {
    if (socket) {
      const handleUpdate = (event) => {
        if (event.action === 'create' && event.data?.cod_usu_lanc !== userLogado?.cod_usu) {
          const currentMuted = localStorage.getItem('sia_sound_muted') === 'true';
          if (!currentMuted) {
            const currentChoice = Number(localStorage.getItem('sia_sound_choice')) || 1;
            playSynthesizedSound(currentChoice);
          }
        }
      };

      const handleAgenda = (event) => {
        if (event.action === 'create' && event.data?.cod_usu_lanc !== userLogado?.cod_usu) {
          const currentMuted = localStorage.getItem('sia_sound_muted') === 'true';
          if (!currentMuted) {
            const currentChoice = Number(localStorage.getItem('sia_sound_choice')) || 1;
            playSynthesizedSound(currentChoice);
          }
        }
      };

      socket.on('atendimento_atualizado', handleUpdate);
      socket.on('agenda_atualizada', handleAgenda);

      return () => {
        socket.off('atendimento_atualizado', handleUpdate);
        socket.off('agenda_atualizada', handleAgenda);
      };
    }
  }, [socket, userLogado]);

  const headerBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(15, 23, 42, 0.8)');
  const activeColor = useColorModeValue('brand.600', 'brand.300');
  const inactiveColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.100', 'whiteAlpha.100');
  const logoFilter = useColorModeValue('none', 'invert(1)');
  const titleColor = useColorModeValue('brand.700', 'white');
  const isPublicRoute =
    location.pathname.startsWith('/tef') ||
    location.pathname.startsWith('/wiki-tef') ||
    location.pathname.startsWith('/areadocliente');

  if (isPublicRoute || !login || IsLogin) {
    return null;
  }

  return (
    <>
      {true && (
        <Box
          position="fixed"
          top="0"
          left="0"
          w="full"
          zIndex="1000"
          bg={headerBg}
          backdropFilter="blur(12px)"
          borderBottom="1px solid"
          borderColor={borderColor}
          transition="all 0.3s"
        >
          <Container maxW="1400px">
            <Flex h={20} alignItems={'center'} justifyContent={'space-between'}>
              <IconButton
                size={'md'}
                variant="ghost"
                icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                aria-label={'Open Menu'}
                display={{ md: 'none' }}
                onClick={isOpen ? onClose : onOpen}
              />

              <HStack spacing={12} alignItems={'center'}>
                <LinkNav to={'/'}>
                  <Flex align="center" gap={2}>
                    <Image src={logo} h="32px" filter={logoFilter} />
                    <Text fontWeight="800" fontSize="xl" letterSpacing="tighter" color={titleColor}>
                      SIA
                    </Text>
                  </Flex>
                </LinkNav>

                <HStack
                  as={'nav'}
                  spacing={1}
                  display={{ base: 'none', md: 'flex' }}
                >
                  <LinkButton
                    title={'DASHBOARD'}
                    link="/"
                    colorB={location.pathname === '/' ? activeColor : inactiveColor}
                  />
                  <ButtonPopver
                    title="SUPORTE"
                    colorB={
                      ['/Atendimento', '/Agendamento', '/Arquivos', '/ConsultaClientes'].includes(location.pathname)
                        ? activeColor
                        : inactiveColor
                    }
                  >
                    <ItemMenu title="Atendimento" link="/Atendimento" icon={FaUserFriends} />
                    <ItemMenu title="Agendamento" link="/Agendamento" icon={FaCalendarTimes} />
                    <ItemMenu title="Consulta de Clientes" link="/ConsultaClientes" icon={FaUsers} />
                    <ItemMenu title="Arquivos" link="/Arquivos" icon={GoFileSubmodule} />
                  </ButtonPopver>
                  <LinkButton
                    title={'DESENVOLVIMENTO'}
                    link="/Desenvolvimento"
                    colorB={location.pathname === '/Desenvolvimento' ? activeColor : inactiveColor}
                  />
                  <ButtonPopver
                    title="ADMINISTRAÇÃO"
                    colorB={
                      ['/BancodeHoras', '/HorasExtras', '/MonitordeClientes', '/CadastraEmpDel', '/usuarios', '/notificacoes', '/LogAcesso'].includes(location.pathname)
                        ? activeColor
                        : inactiveColor
                    }
                  >
                    <ItemMenu title="Banco de Horas" link="/BancodeHoras" icon={FaBusinessTime} />
                    <ItemMenu title="Horas Extras" link="/HorasExtras" icon={FaCalendarPlus} />
                    <ItemMenu title="Usuários" link="/usuarios" icon={FaUsers} />
                    <ItemMenu title="Monitor de Clientes" link="/MonitordeClientes" icon={FaUserFriends} />
                    <ItemMenu title="Empresas Delivery" link="/CadastraEmpDel" icon={FaShippingFast} />
                    <ItemMenu title="Logs de Acesso" link="/LogAcesso" icon={FaHistory} />
                    <ItemMenu title="Notificações" link="/notificacoes" icon={FaBell} />
                  </ButtonPopver>
                </HStack>
              </HStack>

              <Flex alignItems={'center'} gap={2}>
                <Menu closeOnSelect={false}>
                  <Tooltip label="Configuração de Som" placement="bottom">
                    <MenuButton
                      as={IconButton}
                      icon={isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                      variant="ghost"
                      size="md"
                      borderRadius="full"
                      aria-label="Configurações de som"
                    />
                  </Tooltip>
                  <MenuList zIndex={2000}>
                    <MenuItem onClick={handleToggleMute}>
                      <HStack justify="space-between" w="full">
                        <Text fontSize="sm" fontWeight="bold">Silenciar Alertas</Text>
                        <Text fontSize="xs" color="gray.400">{isMuted ? 'Sim' : 'Não'}</Text>
                      </HStack>
                    </MenuItem>
                    <MenuDivider />
                    <MenuOptionGroup
                      title="Escolher Alerta"
                      type="radio"
                      value={String(soundChoice)}
                      onChange={handleSelectSound}
                    >
                      <MenuItemOption value="1" fontSize="sm">Som 1: Clássico Pop</MenuItemOption>
                      <MenuItemOption value="2" fontSize="sm">Som 2: Alerta Digital</MenuItemOption>
                      <MenuItemOption value="3" fontSize="sm">Som 3: Sino Suave</MenuItemOption>
                    </MenuOptionGroup>
                    <MenuDivider />
                    <MenuItem icon={<FaPlay />} onClick={handleTestSound} fontSize="sm" fontWeight="semibold" color="brand.500">
                      Testar Som Selecionado
                    </MenuItem>
                  </MenuList>
                </Menu>
                <NotificacoesBanner />
                <ColorModeSwitcher />
                {login ? (
                  <PerfilPhoto />
                ) : (
                  <Button
                    colorScheme="brand"
                    size="sm"
                    borderRadius="full"
                    px={6}
                    onClick={() => navigate('/login')}
                  >
                    Login
                  </Button>
                )}
              </Flex>
            </Flex>
          </Container>

          {/* Mobile Menu */}
          {isOpen ? (
            <Box pb={4} display={{ md: 'none' }} bg={headerBg} borderBottom="1px solid" borderColor="whiteAlpha.100">
              <Stack as={'nav'} spacing={2} p={4}>
                <LinkButton title={'Dashboard'} link="/" />
                <ButtonSanfona title="Suporte">
                  <ItemMenu title="Atendimento" link="/Atendimento" icon={FaUserFriends} />
                  <ItemMenu title="Agendamento" link="/Agendamento" icon={FaCalendarTimes} />
                  <ItemMenu title="Consulta de Clientes" link="/ConsultaClientes" icon={FaUsers} />
                  <ItemMenu title="Arquivos" link="/Arquivos" icon={GoFileSubmodule} />
                </ButtonSanfona>
                <LinkButton title={'Desenvolvimento'} link="/Desenvolvimento" />
                <ButtonSanfona title="Administração">
                  <ItemMenu title="Banco de Horas" link="/BancodeHoras" icon={FaBusinessTime} />
                  <ItemMenu title="Horas Extras" link="/HorasExtras" icon={FaCalendarPlus} />
                  <ItemMenu title="Usuários" link="/usuarios" icon={FaUsers} />
                  <ItemMenu title="Monitor de Clientes" link="/MonitordeClientes" icon={FaUserFriends} />
                  <ItemMenu title="Empresas Delivery" link="/CadastraEmpDel" icon={FaShippingFast} />
                  <ItemMenu title="Logs de Acesso" link="/LogAcesso" icon={FaHistory} />
                  <ItemMenu title="Notificações" link="/notificacoes" icon={FaBell} />
                </ButtonSanfona>
              </Stack>
            </Box>
          ) : null}

          <IconNotification
            mensagem={'Clique no botão de atualizar para ver o novo atendimento'}
          />
        </Box>
      )}
    </>
  );
}

export default Header;
